import { Link } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import { veracityColors, VeraIconMark, ModuleSwitcher, UserMenu } from '@shared/ui';
import { useAreaTracking } from '@shared/entities/user-activity';
import { BroadcastBanner, BroadcastBell } from '@widgets/broadcast';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: veracityColors.firstLight,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXL}`,
    backgroundColor: '#FFFFFF',
    borderBottom: `1px solid ${veracityColors.firstLight}`,
    boxShadow: tokens.shadow2,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    textDecoration: 'none',
    color: veracityColors.midnightCharcoal,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase500,
  },
  brandAccent: {
    color: veracityColors.veracityOrange,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});

export function ShellLayout({ children }: { children: React.ReactNode }) {
  const styles = useStyles();
  // Same both-shells rule as the banner: the launcher and /admin never pass
  // through AppShell, so without this they emitted no activity at all and the
  // admin activity page could not see the pages admins actually use, itself
  // included (ADO #1558). No nav items here, so areas come from the path.
  useAreaTracking();

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <Link to="/" className={styles.brand}>
          <VeraIconMark height={28} color={veracityColors.veracityOrange} />
          <span className={styles.brandAccent}>Vera</span>
        </Link>
        <div className={styles.right}>
          {/* Same both-shells rule as the banner below: the launcher and
              /admin never pass through AppShell. */}
          <BroadcastBell />
          <ModuleSwitcher />
          <UserMenu />
        </div>
      </header>
      {/* The launcher and /admin do not pass through AppShell, so the banner
          is mounted here too. Missing this is how a "global" banner ends up
          invisible on the page people actually land on. */}
      <BroadcastBanner />
      <main className={styles.main}>{children}</main>
    </div>
  );
}
